import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Register the necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function SalesReportChart() {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Sales',
        data: [12, 19, 3, 5, 2, 3, 7, 10, 15, 20, 18, 25],
        fill: true,
        backgroundColor: 'rgba(76, 132, 255, 0.2)', // Same as your primary color
        borderColor: '#4c84ff',
        borderWidth: 2,
        tension: 0.4,
      },
      {
        label: 'Revenue',
        data: [15, 20, 5, 8, 4, 6, 9, 13, 18, 22, 20, 27],
        fill: true,
        backgroundColor: 'rgba(128, 225, 193, 0.2)', // Same as your secondary color
        borderColor: '#80e1c1',
        borderWidth: 2,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0,0,0,0.05)',
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div style={{ position: 'relative', height: '247px' }}>
      <Line data={data} options={options} />
    </div>
  );
}

export default SalesReportChart;
